import { useContext, useMemo } from "react";
import { CliContext } from "../reducer/context";

export const useCliContext = () => {
  const { state, dispatch } = useContext(CliContext);
  return useMemo(() => ({ state, dispatch }), [state, dispatch]);
};
